// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2Eb1g","title":"BackImages_title__2RtwO","images":"BackImages_images__m5fmr"};